const VENDOR_NAME_PATTERN = /stripe|dwolla|moov|check\s*flo|checkbook|plaid/i;

export const VENDOR_NEUTRAL_ERROR_MESSAGE =
  "We couldn't process this information. Please check your details and try again, or contact support.";

export function toVendorNeutralMessage(message: string): string {
  return VENDOR_NAME_PATTERN.test(message) ? VENDOR_NEUTRAL_ERROR_MESSAGE : message;
}
